import HttpClient from '@/services/http-client'

class ManufactorService extends HttpClient {
  async show(id) {
    return this.rest.get('/v1/manufactors/' + id)
  }

  async list(page = 1, limit = 1000, text = null) {
    return this.rest.get('/v1/manufactors', {
      params: {
        page,
        limit,
        q: text
      }
    })
  }

  async create(payload) {
    return this.rest.post('/v1/manufactors', payload)
  }

  async update(payload) {
    return this.rest.patch('/v1/manufactors/' + payload.id, payload)
  }

  async delete(id) {
    return this.rest.delete('/v1/manufactors/' + id)
  }
}

export default () => new ManufactorService()
